<template>
    <b-modal
        :title="titulo"
        id="modalAssinaturaDigital"
        v-model="exibirModalLocal"
        scrollable
        centered
        no-close-on-esc
        no-close-on-backdrop>

        <form>
            <alert
                :variant="alert.variant"
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed">
            </alert>

            <b-row>
                <b-col >
                    <b-form-group
                        label="Documento"
                        label-size="sm">
                        <b-input-group>
                            <b-form-file
                                class="input-file"
                                ref="arquivo"
                                :accept="extensoesPermitidas.toString()"
                                v-model="arquivo"
                                @input="inputDocumento"
                                placeholder="Clique para selecionar um documento"
                                size="sm"
                                aria-describedby="feedback_arquivo"
                                :state="$helper.validarEstadoCampo(arquivo, '')"
                                >
                            </b-form-file>
                        </b-input-group>
                        <b-form-invalid-feedback id="feedback_arquivo">Campo Obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="">
                <b-col >
                    <b-form-group
                        label="Certificado"
                        label-size="sm">
                            <b-form-select
                                :options="certificados.options"
                                v-model="certificadoSelecionado"
                                aria-describedby="feedback_certificadoSelecionado"
                                :state="$helper.validarEstadoCampo(certificadoSelecionado, '')"
                                >
                            </b-form-select>
                            <b-form-invalid-feedback id="feedback_certificadoSelecionado">Campo Obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

        </form>

        <template v-slot:modal-footer>
            <b-btn variant="danger" @click="sair" >
                <i class="fa fa-sign-out pr-1"></i> Sair
            </b-btn>
            <b-btn variant="success" @click="assinarDocumento" >
                <i class="fa fa-pencil-square-o pr-1"></i> Assinar Documento
            </b-btn>
        </template>
        </b-modal>
</template>
<script>
import Alert from '../models/Alert'
import LacunaWebPKI from 'web-pki';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
    name: "ModalAssinaturaDigital",
    mixins: [validationMixin],
    props: {
        titulo: { type: String, default: '' },
        exibirModal: { type: Boolean, default: false },
        extensoesPermitidas: { type: Array, default: new Array() },
        tamanhoArquivo: { type: Number, default: null },
    },

    data(){
        return {
            exibirModalLocal: false,
            arquivo: null,
            certificadoSelecionado: null,
            certificados:{
                options:[]
            },
            pki: null,
            alert: new Alert(),
            tipoArquivo: null
        }
    },
    validations: {
        arquivo: {
            required,
        },
        certificadoSelecionado: {
            required,
        },
    },
    methods: {
        alertDismissed(){
            this.alert = new Alert();
        },

        verificaTamanhoArquivo(){
            if(this.arquivo != null && this.tamanhoArquivo != null) {
                if (this.arquivo.size > this.tamanhoArquivo){
                    this.arquivo = [];
                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.WARNING,
                                           `Tamanho máximo do arquivo deve ser de ${this.$helper.bytesToSize(this.tamanhoArquivo)}.`);
                    return false;
                }
            }
            return true;
        },

        inputDocumento(){
            if(this.arquivo){
                if(!this.$helper.validaExtensaoArquivo(this.arquivo.name, this.extensoesPermitidas)){
                    this.$helper.showAlert(this.alert,
                                        this.$constantes.alert.variants.WARNING,
                                        'Extensão do arquivo não suportada. Escolha arquivos com as extensões: ' +  this.extensoesPermitidas.toString());
                    this.$refs.arquivo.reset();
                    return;
                }

                if(!this.verificaTamanhoArquivo()){
                    this.$refs.arquivo.reset();
                    return;
                }

                this.tipoArquivo = this.$helper.getExtensaoArquivo(this.arquivo.name).toLowerCase().replace(".", "");
            }
        },

        preencherCertificados(){
            var t = this;
            this.pki.listCertificates()
            .success(function (certs) {
                certs.forEach(cert => {
                    let texto = cert.subjectName + '(' + cert.issuerName + ')';
                    let expirado =  new Date() > cert.validityEnd;
                    if (expirado) {
                        texto = '[EXPIRADO] ' + texto;
                    }
                    let option = {
                        value: cert,
                        text: texto,
                        disabled: expirado
                    };
                    t.certificados.options.push(option);
                    t.certificadoSelecionado = t.certificados.options[0].value;
                });
            })
            .fail((ex) => {
                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.DANGER,
                                       'Erro ao recuperar a lista de certificados: ' + ex.userMessage);
            });

        },

        sair(){
            this.exibirModalLocal = false;
        },

        validaCamposObrigatoriosPreenchidos() {
            return (this.arquivo &&
                    this.certificadoSelecionado);
        },

        getFormDataDocumento(arquivo){
            const formData = new FormData();
            formData.append('arquivo', arquivo);
            return formData;
        },

        assinarDocumento(){
            var t = this;
            if(this.validaCamposObrigatoriosPreenchidos()){
                const formData = this.getFormDataDocumento(this.arquivo);
                //Inicia a assinatura no servidor
                this.$api.assinaturadigital.iniciar(this.tipoArquivo, formData)
                    .then(response => {
                        if(response.status == 200 || response.status == 201){
                            t.$router.app.carregando = true;
                            let token = response.data.data.token;
                            let hash = response.data.data.hash;

                            //Assina o token do documento com certificado presente no cliente
                            this.pki.signWithRestPki({
                                token: token,
                                thumbprint: this.certificadoSelecionado.thumbprint
                            }).success(function() {
                                let parms = {
                                    token: token
                                };
                                //Finaliza o processo de assinatura do servidor
                                t.$api.assinaturadigital.finalizar(t.tipoArquivo, parms)
                                    .then(response => {
                                        if(response.status == 200 || response.status == 201){
                                            let arquivoBase64 = response.data.data.arquivo;
                                            t.$emit('arquivoAssinadoBase64', arquivoBase64, t.arquivo.name, hash);
                                            t.$helper.showAlert(t.alert,
                                                                t.$constantes.alert.variants.SUCCESS,
                                                                'Documento assinado com sucesso!');

                                        }
                                    })
                                    .catch(error => {
                                        t.$helper.showAlert(t.alert,
                                                            t.$constantes.alert.variants.DANGER,
                                                            error.response.data.errors);
                                    });
                            })
                            .fail((ex)=> {
                                this.$helper.showAlert(this.alert,
                                                       this.$constantes.alert.variants.DANGER,
                                                       'Erro ao assinar documento: ' + ex.userMessage);
                            });
                        }
                    })
                    .catch(error => {
                        this.$helper.showAlert(this.alert,
                                               this.$constantes.alert.variants.DANGER,
                                               error.response.data.errors);
                    });
            }else{
                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.DANGER,
                                       'Existe(m) campo(s) obrigatório(s) não preenchido(s).');
            }
        },
    },
    mounted(){
        this.exibirModalLocal = this.exibirModal;

        this.pki = new LacunaWebPKI(this.$env.VUE_APP_LACUNA_WEBPKI_LICENSE);
        this.pki.init({
            ready: this.preencherCertificados(),
            restPkiUrl: this.$env.VUE_APP_LACUNA_RESTPKI_URL
        }).success(() => {

        })
        .fail((ex) => {
            this.$helper.showAlert(this.alert,
                                   this.$constantes.alert.variants.DANGER,
                                   'Erro ao inicializar pki web: ' + ex.userMessage);
        });
    },
    watch: {
        exibirModalLocal: function () {
            this.$emit('update:exibirModal', this.exibirModalLocal);
        }
    }
}
</script>

<style scoped>

</style>
